import React, { useState } from "react";
import "./styles.css";
import down from "../../Assets/Icons/icon_down_arrow.png";
import up from "../../Assets/Icons/icon_up_arrow.png";

const Accordion = (props) => {
  const [open, setOpen] = useState(false);

  const handleCheckbox = (e, item) => {
    if (e.target.checked === true) {
      props.setCheckedItems([...props.checkedItems, item]);
    } else {
      props.setCheckedItems(
        props.checkedItems.filter((i) =>
          item?.schemaVariable
            ? i?.schemaVariable !== item?.schemaVariable
            : i !== item
        )
      );
    }
  };

  return (
    <div className="accordion-item-container" style={props.style}>
      <div
        className="accordion-item-heading"
        onClick={() => setOpen((open) => !open)}
      >
        <div className="flex-row-start">
          <div className="bullet"></div>
          <p>{props.text}</p>
        </div>
        {!open ? (
          <img src={down} className="icon" />
        ) : (
          <img src={up} className="icon" />
        )}
      </div>
      {open && props.listType === "anchor" && (
        <ul>
          {props?.array && props.array.length > 0 ? (
            props?.array?.map((item, index) => {
              // if (props.listType === "anchor") {
              return (
                <li className="body1 dark-grey p-5" key={index}>
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.name}
                  </a>
                </li>
              );
            })
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <p className="body1 medium-grey">No Data available</p>
            </div>
          )}
        </ul>
      )}{" "}
      {open && props.listType === "checkbox" && (
        <ul
          style={{
            listStyle: "none",
            padding: 0,
          }}
        >
          {props?.array?.map((item, index) => (
            <li className="body1 dark-grey p-5" key={index}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {" "}
                <input
                  type="checkbox"
                  onChange={(e) => {
                    // console.log(e.target.name);
                    handleCheckbox(e, item);
                  }}
                  name={item?.schemaVariable || item}
                  checked={props.checkedItems.find((i) =>
                    item?.schemaVariable
                      ? i?.schemaVariable === item?.schemaVariable
                      : i === item
                  )}
                />
                <label className="body1 dark-grey">{item?.name || item}</label>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Accordion;
